import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import profileImg from 'contents/assets/img/@profile.png';
import PopPosition from '../_PopPosition';
import PopIncome from '../_PopIncome';
import PopLeave from '../_PopLeave';
import PopManageSalary from '../../manage/_PopManageSalary';
import PopManagePosition from '../../manage/_PopManagePosition';
function EmployeeInfo() {
  const [modalPositionOpen, setModalPositionOpen] = useState(false);
  const [modalIncomeOpen, setModalIncomeOpen] = useState(false);
  const [modalLeaveOpen, setModalLeaveOpen] = useState(false);
  const [modalManageSalary, setModalManageSalary] = useState(false);
  const [modalManagePosition, setModalManagePosition] = useState(false);
  return (
    <main className="com_container com_member_info">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_11">
            내 정보 <span className="bar" />
            <span className="point_txt">최교사103</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            {/* 프로필 */}
            <div className="info_top">
              <div className="thumb">
                <img src={profileImg} alt="프로필 이미지" />
                <button className="btn_camera"></button>
              </div>
              <div className="com_input_wrap">
                <div className="input_row">
                  <input type="text" className="input" placeholder="내근직원 이름" />
                  <select className="select">
                    <option value="법인 선택">법인 선택</option>
                  </select>
                  <div className="check">
                    <input type="radio" name="rdo1" id="rdo06" className="com_chk circle" />
                    <label htmlFor="rdo06">정규직</label>
                    <input type="radio" name="rdo1" id="rdo07" className="com_chk circle" />
                    <label htmlFor="rdo07">프리랜서 </label>
                    <input type="radio" name="rdo1" id="rdo05" className="com_chk circle" />
                    <label htmlFor="rdo05">계약직 </label>
                  </div>
                </div>
                <div className="input_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <div className="check">
                    <input type="radio" name="rdo_sex" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">남</label>
                    <input type="radio" name="rdo_sex" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">여</label>
                  </div>
                  <button className="com_btn orange xs">재직</button>
                </div>
                <div className="input_row">
                  <ul className="part_list">
                    <li>
                      <div className="input_row">
                        <select className="select">
                          <option value="본사">본사</option>
                          <option value="지사">지사</option>
                        </select>
                        <select className="select">
                          <option value="전략기획실">전략기획실</option>
                          <option value="인사팀">인사팀</option>
                        </select>
                        <select className="select">
                          <option value="수시팀">수시팀</option>
                        </select>
                        <select className="select">
                          <option value="담당">담당</option>
                        </select>
                        <select className="select">
                          <option value="담당2">담당2</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      <div className="input_row">
                        <select className="select">
                          <option value="전략기획실">전략기획실</option>
                          <option value="인사팀">인사팀</option>
                        </select>
                        <select className="select">
                          <option value="수시팀">수시팀</option>
                        </select>
                        <select className="select">
                          <option value="담당">담당</option>
                        </select>
                        <select className="select">
                          <option value="담당2">담당2</option>
                        </select>
                      </div>
                      <button className="btn_add_gray"></button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 상세 */}
            <table className="com_board_list type_row">
              <colgroup>
                <col width="10%" />
                <col width="35%" />
                <col width="10%" />
                <col width="35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>아이디</th>
                  <td className="type_row bold">ase234@naver.com </td>
                  <th>직급</th>
                  <td>
                    <div className="com_input_wrap flex_between">
                      부장 (2021, 05., 12 (부장 3년차))
                      <button onClick={() => setModalManagePosition(true)} className="com_btn gray xs">
                        직급변경
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>비밀번호</th>
                  <td className="type_row">!@#**2344</td>
                  <th>직책</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="직책">직책</option>
                        <option value="팀장">팀장</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>휴대폰</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`010-2322-2222`} />
                    </div>
                  </td>
                  <th>연봉</th>
                  <td>
                    <div className="com_input_wrap flex_between">
                      <input type="password" className="input" defaultValue={`7000`} />
                      <button onClick={() => setModalManageSalary(true)} className="com_btn gray xs">
                        연봉보기
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                  <th>학력 / 전공</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`한국방송통신대`} />
                      <input type="text" className="input" defaultValue={`미디어영상학과`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>입사일</th>
                  <td colSpan={3}>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <span className="txt">입사 12년차</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>보험</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="보헙가입일" />
                      <input type="date" className="com_datepicker" placeholder="보험유지일" />
                    </div>
                  </td>
                  <th>계좌 정보</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="하나은행">하나은행</option>
                      </select>
                      <input type="text" className="input ws" defaultValue={`홍길동`} />
                      <input type="text" className="input wl" defaultValue={`828282918292`} />
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>면접/소개/컨택자</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="면접자">면접자</option>
                      </select>
                      <select className="select wm">
                        <option value="소개자">소개자</option>
                      </select>
                      <select className="select wm">
                        <option value="컨택자">컨택자</option>
                      </select>
                    </div>
                  </td>
                  <th rowSpan={2}>경력</th>
                  <td rowSpan={2}>
                    <div className="txt">
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                      **에듀에서 영어강사로 3년 근무
                      <br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>주소</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" placeholder="주소" />
                      <button className="com_btn gray xs">우편번호</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td>
                    <input type="text" className="input" placeholder="주소" />
                  </td>
                  <th>메모</th>
                  <td>
                    <div className="txt_memo">
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                      메모메모메모
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">수정</button>
              <button
                onClick={() => {
                  setModalLeaveOpen(true);
                }}
                className="com_btn line gray s btn_enter"
              >
                회원 탈퇴
              </button>
            </div>
          </section>
        </section>
      </div>
      <PopPosition open={modalPositionOpen} close={() => setModalPositionOpen(false)} />
      <PopIncome open={modalIncomeOpen} close={() => setModalIncomeOpen(false)} />
      <PopLeave open={modalLeaveOpen} close={() => setModalLeaveOpen(false)} />
      <PopManageSalary open={modalManageSalary} close={() => setModalManageSalary(false)} />
      <PopManagePosition open={modalManagePosition} close={() => setModalManagePosition(false)} />
    </main>
  );
}

export default EmployeeInfo;
